const template = {
    name: "Default NEC4 TSS v4.2 18/07/2025",
    isSystemDefault: true,
    isGlobal: true,
    companies: [],
    resources: [
        {
            id: 1,
            type: "TEXT",
            key: "SUPPLIER_NAME",
            value: "Subcontractor"
        },
        {
            id: 2,
            type: "TEXT",
            key: "SUPPLIER_ABBREVIATION",
            value: "SUB"
        },
        {
            id: 3,
            type: "TEXT",
            key: "PM_NAME",
            value: "Contractor"
        },
        {
            id: 4,
            type: "TEXT",
            key: "PM_ABBREVIATION",
            value: "CON"
        },
        {
            id: 5,
            type: "TEXT",
            key: "SUPERVISOR_NAME",
            value: "Supervisor"
        },
        {
            id: 6,
            type: "TEXT",
            key: "SUPERVISOR_ABBREVIATION",
            value: "SUP"
        },
        {
            id: 7,
            type: "TEXT",
            key: "CLIENT_NAME",
            value: "Client"
        },
        {
            id: 8,
            type: "NUMBER",
            key: "SUPPLIER_REPLY_PERIOD",
            value: 7
        },
        {
            id: 9,
            type: "NUMBER",
            key: "PM_REPLY_PERIOD",
            value: 14
        },
        {
            id: 10,
            type: "NUMBER",
            key: "QUOTE_DURATION",
            value: 14
        },
        {
            id: 13,
            type: "NUMBER",
            key: "REQUOTE_DURATION",
            value: 14
        },
        {
            id: 11,
            type: "NUMBER",
            key: "QUOTE_RESPONSE",
            value: 28
        },
        {
            id: 14,
            type: "NUMBER",
            key: "REQUOTE_RESPONSE",
            value: 28
        },
        {
            id: 12,
            type: "NUMBER",
            key: "VARIATION_RESPONSE",
            value: 14
        },
        {
            id: 16,
            type: "NUMBER",
            key: "PROGRAMME_REPLY_PERIOD",
            value: 14
        },
        {
            id: 18,
            type: "TEXT",
            key: "COMPLETION_DATE",
            value: "Service Period end date"
        },
        {
            id: 8,
            type: "TEXT",
            key: "CLIENT_ABBREVIATION",
            value: "CLI"
        },
        {
            id: 10,
            type: "TEXT",
            key: "QUOTE_DEEMED_ACCEPTANCE_STARTS",
            value: "RELATED_NOTICE"
        },
        {
            id: 39,
            type: "TEXT",
            key: "CEN_DEEMED_ACCEPTANCE_STARTS",
            value: "RELATED_NOTICE"
        },
        {
            id: 40,
            type: "NUMBER",
            key: "CEN_DEEMED_ACCEPTANCE",
            value: 21
        },
        {
            id: 25,
            type: "NUMBER",
            key: "QUOTE_DEEMED_ACCEPTANCE",
            value: 21
        },
        {
            id: 41,
            type: "TEXT",
            key: "PROG_DEEMED_ACCEPTANCE_STARTS",
            value: "RELATED_NOTICE"
        },
        {
            id: 42,
            type: "NUMBER",
            key: "PROG_DEEMED_ACCEPTANCE",
            value: 14
        }
    ],
    workflowGroups: [
        {
            id: 101,
            title: "Early Warnings",
            workflows: [
                {
                    id: 1,
                    title: "$PM_NAME Early Warnings",
                    notificationName: "Early Warning",
                    abbreviation: "$PM_ABBREVIATION-Warning-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    replyPeriod: 7,
                    notifyingParty: "PM",
                    replyingParty: "SUPPLIER",
                    actioningParty: "PM",
                    resolveActioningParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        actionTab: {
                            actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]",
                        resolveActionTab: {
                            resolveActionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        }
                    }
                },
                {
                    id: 2,
                    title: "$SUPPLIER_NAME Early Warnings",
                    notificationName: "Early Warning",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Warning-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "PM_REPLY_PERIOD",
                    replyPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    actioningParty: "PM",
                    resolveActioningParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        actionTab: {
                            actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]",
                        resolveActionTab: {
                            resolveActionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        }
                    }
                },
                {
                    id: 3,
                    title: "Early Warning Register",
                    notificationName: "Early Warning",
                    abbreviation: "Warning",
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "MeetingRequiredLabel",
                            display: "Is Early Warning Meeting required?",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "NotificationClause",
                            display: "You are given early warning of a matter which could",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "RiskItemsLabel",
                            display: "You are given early warning of a matter which could",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "RiskTypes",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "riskincreaseprice",
                            display: "increase the total of the Prices",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "riskservicetiming",
                            display: "interfere with the timing of the service",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "riskserviceperformance",
                            display: "impair the effectiveness of the service",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "riskincreasecontractorcost",
                            display: "increase the $SUPPLIER_NAME's cost",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "riskaffectmodel",
                            display: "adversely affect the creation or use of the Information Model (X10.3)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "riskotherpartner",
                            display: "affect the achievement of another Partner's objectives (X12.3)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 15,
                            isActive: true,
                            field: "riskenvironment",
                            display: "adversely affect the achievement of the Climate Change Requirements (X29.3)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: false,
                            field: "riskcontractbreach",
                            display: "Affect the achievement of another Partner’s objectives",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "riskdelaymilestone",
                            display: "Delay meeting a Key Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: false,
                            field: "riskincreasedefinedcost",
                            display: "Increase the Defined Cost of expending any Provisional Sums",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: false,
                            field: "riskaffectsafety",
                            display: "Adversely affect the $SUPPLIER_NAME’s ability to safely carry out the works",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "RiskStatusOptions",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Mitigated",
                            display: "Mitigated",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "NotMitigated",
                            display: "Not Mitigated",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Pm",
                            display: "$WF_1_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Supplier",
                            display: "$WF_2_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Client",
                            display: "$WF_74_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "MeetingOptions",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "0",
                            display: "Extra meeting not required",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "1",
                            display: "To be discussed at next scheduled early warning meeting",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "2",
                            display: "You are instructed to attend an early warning meeting as follows",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 102,
            title: "Instructions",
            workflows: [
                {
                    id: 4,
                    title: "$PM_NAME Instruction",
                    notificationName: "Instruction",
                    abbreviation: "$PM_ABBREVIATION-Instruction-",
                    notify: true,
                    replyEnabled: false,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "PM_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "PM",
                    replyingParty: "SUPPLIER",
                    form_IncludeCompanyName: false,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "InstructionTypes",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "14.3 to change the Scope, a Task or the Affected Property",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: true,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_5",
                                    timePeriod: "CUSTOM"
                                }
                            ]
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "",
                            display: "14.5 to correct a mistake in the Price List",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "",
                            display: "17.1 stating how to resolve an ambiguity or inconsistency",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "",
                            display: "17.2 to change the Scope to remove something which is illegal or impossible",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: true,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_5",
                                    timePeriod: "CUSTOM"
                                }
                            ]
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "",
                            display: "19.1 to submit a quotation for a Task",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "",
                            display: "21.1 to submit particulars of design of an item of Equipment",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "SUPPLIER",
                                    actionType: "WF_18",
                                    timePeriod: "SUPPLIER_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "",
                            display: "22.2 to remove a person",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "",
                            display: "32.2 to submit a revised plan",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "SUPPLIER",
                                    actionType: "WF_18",
                                    timePeriod: "SUPPLIER_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "",
                            display: "34.2 to submit a revised Task Order programme",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "SUPPLIER",
                                    actionType: "WF_18",
                                    timePeriod: "SUPPLIER_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "",
                            display: "36.1 to stop or not start work",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: true,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_5",
                                    timePeriod: "CUSTOM"
                                }
                            ]
                        },
                        {
                            id: 18,
                            isActive: true,
                            field: "",
                            display: "36.1 to start or restart work",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "",
                            display: "40.3 to correct a failure to comply with the quality plan",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 13,
                            isActive: true,
                            field: "",
                            display: "62.1 to submit alternative quotations for a compensation event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 14,
                            isActive: true,
                            field: "",
                            display: "92.2 to remove Equipment, Plant and Materials and assign the benefit of the subcontract to the Client",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 15,
                            isActive: true,
                            field: "",
                            display: "X10.4(3) to submit a revised Information Execution Plan",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "SUPPLIER",
                                    actionType: "WF_18",
                                    timePeriod: "SUPPLIER_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 16,
                            isActive: true,
                            field: "",
                            display: "X12.1(6) providing Partnering Information",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 19,
                            isActive: true,
                            field: "",
                            display: "X29.4(4) to submit a revised climate change plan",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "SUPPLIER",
                                    actionType: "WF_18",
                                    timePeriod: "SUPPLIER_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 17,
                            isActive: true,
                            field: "",
                            display: "Other Instruction",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "PM",
                            display: "$WF_4_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Supervisor",
                            display: "$WF_61_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Client",
                            display: "$WF_56_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 114,
            title: "Task Orders",
            workflows: [
                {
                    id: 62,
                    title: "$PM_NAME Instruction to Quote for a Task",
                    notificationName: "Instruction to Quote for a Task",
                    abbreviation: "$PM_ABBREVIATION-ITQ-",
                    notify: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    quotingParty: "SUPPLIER",
                    quoteReplyingParty: "PM",
                    quoteNotificationName: "TO-Quote",
                    quoteReferencePrefix: "TO-Quote-",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        quoteMainNotice: {
                            createQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        quoteReplyNotice: {
                            saveQuoteDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateQuoteReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                },
                {
                    id: 38,
                    title: "$PM_NAME Task Orders",
                    notificationName: "Task Order",
                    abbreviation: "$PM_ABBREVIATION-Task-",
                    notify: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Note",
                            display: "Your quote is accepted as set out below, or we make our own assessment as set out below and we notify as follows",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "DescriptionLabel",
                            display: "Detailed description of the work in the task",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "ItemsListLabel",
                            display: "Items taken from price list",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "TotalListPriceLabel",
                            display: "Price list total",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "CompensationDescriptionLabel",
                            display: "Items assessed in the same way as a compensation event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "TotalAssessedLabel",
                            display: "Assessed list total",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "TotalPriceLabel",
                            display: "Total of prices",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "StartDateLabel",
                            display: "Start Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "CompletionDateLabel",
                            display: "Completion Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "DelayAmountLabel",
                            display: "Amount of delay damages for the late completion of the task",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "DelayPaymentPeriodLabel",
                            display: "Delay damages period",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "WarningBanner",
                            display: "A Task Order is not instructed after the end of the service period.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 13,
                            isActive: true,
                            field: "RequestForQuoteNote",
                            display: "You are instructed to provide a quotation for a proposed Task Order by $date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 14,
                            isActive: true,
                            field: "QuoteNoteRequestForQuote",
                            display: "We submit our quotation for $reference",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 15,
                            isActive: true,
                            field: "RequestForQuoteDescription",
                            display: "Items assessed in the same way as a request for quote",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "Fields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Description",
                            display: "Detailed description",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "ItemsList",
                            display: "Items taken from price list",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "TotalListPrice",
                            display: "Price list total",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "CompensationDescription",
                            display: "Items assessed in the same way as a compensation event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "TotalAssessed",
                            display: "Assessed list total",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "TotalPrice",
                            display: "Total of prices",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "StartDate",
                            display: "Start Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "CompletionDate",
                            display: "Completion Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "DelayAmount",
                            display: "Amount of delay damages for the late completion of the task",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "DelayPaymentPeriod",
                            display: "Delay damages calculation period",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: false,
                            field: "Comments",
                            display: "Comments",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "RFQRelationEnabled",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "RFQRelationEnabled",
                            display: "Active-Inactive state indicates whether the RFQ can be attached in Task Order communications",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "RFQStatuses",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "APMA",
                            display: "Awaiting $WF_38_NOTIFICATION_NAME",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "ARQ",
                            display: "Quote Not Accepted - $SUPPLIER_NAME to resubmit",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "AM",
                            display: "Task Order Issued",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "QA",
                            display: "Quote Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "APMRQ",
                            display: "Awaiting $PM_NAME Response to quote",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "APMR",
                            display: "Awaiting $PM_Name Response to notice",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "AQ",
                            display: "Awaiting Quote",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "NC",
                            display: "Not Communicated",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "R",
                            display: "Rejected",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "DNG",
                            display: "Proposed Task will not be instructed",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "QuoteStatuses",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "0",
                            display: "Not Accepted - $SUPPLIER_NAME to resubmit",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "1",
                            display: "Accepted - Task Order to follow",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "2",
                            display: "Awaiting Response",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "3",
                            display: "Not Accepted - $PM_NAME will be making the assessment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "4",
                            display: "Not Accepted - Other quote approved",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "5",
                            display: "Not Accepted - Proposed Task will not be instructed",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "none",
                            display: "Not Communicated",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "RfqReplyProceedEnabled",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "RfqReplyProceedEnabled",
                            display: "RFQ Quote Reply field proceed options Enabled/Disabled",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "QuoteFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Description",
                            display: "Detailed description",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "ItemsList",
                            display: "Items taken from price list",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "TotalListPrice",
                            display: "Price list total",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "RequestForQuoteDescription",
                            display: "Items assessed in the same way as a compensation event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "TotalAssessed",
                            display: "Assessed list total",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "TotalPrice",
                            display: "Total of prices",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "StartDate",
                            display: "Start Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "CompletionDate",
                            display: "Completion Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "DelayAmount",
                            display: "Amount of delay damages for the late completion of the task",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "DelayPaymentPeriod",
                            display: "Delay damages calculation period",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "Comments",
                            display: "Comments",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "RFQFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "StartDate",
                            display: "Start Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "CompletionDate",
                            display: "Completion Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "DelayAmount",
                            display: "Amount of delay damages for the late completion of the task",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "DelayPaymentPeriod",
                            display: "Delay damages calculations period",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "RFQRelationRequired",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "RFQRelationRequired",
                            display: "Active-Inactive state indicates whether a Task Order can be issued without selecting an associated RFQ",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "QuoteRfqImpactOpts",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "noeffect",
                            display: "There is no effect on the $COMPLETION_DATE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: false,
                            field: "mitigated",
                            display: "There is an effect on the $COMPLETION_DATE but this has been mitigated by measures as detailed",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "notmitigated",
                            display: "There is an effect on the $COMPLETION_DATE which we are unable to mitigate",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "PmRfqAQ",
                            display: "$WF_62_TITLE awaiting quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "PmRfqARQ",
                            display: "$WF_62_TITLE awaiting revised quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "PmRfqAPMRQ",
                            display: "$WF_38_NOTIFICATION_NAME quotations awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "PmRfqAPMA",
                            display: "Awaiting $WF_62_NOTIFICATION_NAME",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "replydraftpmcequotessupplier",
                            display: "$WF_38_NOTIFICATION_NAME quotation reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "draftconrfqquotation",
                            display: "$WF_38_NOTIFICATION_NAME quotation",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 103,
            title: "Compensation Events",
            workflows: [
                {
                    id: 5,
                    title: "$PM_NAME Compensation Events",
                    notificationName: "Compensation Event",
                    abbreviation: "$PM_ABBREVIATION-Compensation-",
                    notify: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    quotingParty: "SUPPLIER",
                    quoteReplyingParty: "PM",
                    quoteNotificationName: "Quote",
                    quoteReferencePrefix: "Quote-",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        quoteMainNotice: {
                            createQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        quoteReplyNotice: {
                            saveQuoteDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateQuoteReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                },
                {
                    id: 6,
                    title: "$PM_NAME Proposed Instructions",
                    notificationName: "Proposed Instruction",
                    abbreviation: "$PM_ABBREVIATION-PROP-",
                    notify: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    quotingParty: "SUPPLIER",
                    quoteReplyingParty: "PM",
                    quoteNotificationName: "Quote",
                    quoteReferencePrefix: "Quote-",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        quoteMainNotice: {
                            createQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        quoteReplyNotice: {
                            saveQuoteDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateQuoteReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                },
                {
                    id: 7,
                    title: "$SUPPLIER_NAME Compensation Events",
                    notificationName: "Compensation Event",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Compensation-",
                    notify: true,
                    replyEnabled: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "VARIATION_RESPONSE",
                    replyPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    quotingParty: "SUPPLIER",
                    quoteReplyingParty: "PM",
                    quoteNotificationName: "Quote",
                    quoteReferencePrefix: "Quote-",
                    form_IncludeCompanyName: false,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        quoteMainNotice: {
                            createQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        quoteReplyNotice: {
                            saveQuoteDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateQuoteReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                },
                {
                    id: 8,
                    title: "$PM_NAME CE Assessments",
                    notificationName: "Assessment of a Compensation Event",
                    abbreviation: "$PM_ABBREVIATION-CE-Assessment-",
                    notify: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                },
                {
                    id: 9,
                    title: "$PM_NAME Extensions",
                    notificationName: "Extension",
                    abbreviation: "$PM_ABBREVIATION-Extension-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "ORIGINAL_DATE",
                    replyPeriod: 0,
                    notifyingParty: "PM",
                    replyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]"
                    }
                },
                {
                    id: 10,
                    title: "$SUPPLIER_NAME Extensions",
                    notificationName: "Extension",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Extension-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "ORIGINAL_DATE",
                    replyPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]"
                    }
                },
                {
                    id: 11,
                    title: "Master Quote Register",
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null"
                    }
                },
                {
                    id: 12,
                    title: "Master CE Register",
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null"
                    }
                },
                {
                    id: 13,
                    title: "Implemented CE Register",
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "PmAssumptionLabel",
                            display: "The quotation is to be based on the following assumptions",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "PmAssumptionNote",
                            display: "You are instructed to provide a quotation by $date.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "SupplierDescNote",
                            display: "You are notified of the following as a compensation event:",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "ReplyAcceptedCommentLabel",
                            display: "You are notified of the $PM_NAME's decision that the matter notified is a compensation event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "ReplyRejectedCommentLabel",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "ReplyAcceptedAssumptionLabel",
                            display: "The quotation is to be based on the following assumptions",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "QuoteNote",
                            display: "We submit our quotation for compensation event $reference",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "ExtensionPMLabel",
                            display: "We require an extension to the time to reply as follows",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "ExtensionSupplierLabel",
                            display: "We require an extension to the time to reply as follows",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "AssessmentDetailLabel",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "ProposedInstructionNote",
                            display: "You are instructed to provide a quotation by $date.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "ProposedInstructionLabel",
                            display: "The quotation is to be based on the following assumptions",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 13,
                            isActive: true,
                            field: "ReplyRejectedOptionsLabel",
                            display: "You are notified of the $PM_NAME's decision that the matter notified is not a compensation event as it",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 14,
                            isActive: true,
                            field: "QuoteCostEffectLabel",
                            display: "Change to the Prices",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 15,
                            isActive: true,
                            field: "QuoteDateEffectLabel",
                            display: "Delay",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 16,
                            isActive: true,
                            field: "QuoteDaysEffectLabel",
                            display: "The length of time that the $COMPLETION_DATE is delayed",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 17,
                            isActive: true,
                            field: "AssessmentCostEffectLabel",
                            display: "Change in the Total of the Prices",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 18,
                            isActive: true,
                            field: "AssessmentDaysEffectLabel",
                            display: "The length of time that the $COMPLETION_DATE is delayed",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 19,
                            isActive: true,
                            field: "QuoteProgrammeAttachLabel",
                            display: "Are you attaching a programme or plan showing the effect against the last programme or plan with this quotation?",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 20,
                            isActive: true,
                            field: "QuoteNoteProposedInstruction",
                            display: "We submit our quotation for proposed compensation event $reference",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 21,
                            isActive: true,
                            field: "ReplyAcceptedAssumptionNote",
                            display: "You instructed to submit a quotation by $date.",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CompensationClauses",
                    values: [
                        {
                            id: 25,
                            isActive: true,
                            field: "",
                            display: "60.1(1) of an instruction to change the Subcontract Scope a Task or the Affected Property",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 26,
                            isActive: true,
                            field: "",
                            display: "60.1(2) that the $PM_NAME does not provide the right of access to the Affected Property",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 27,
                            isActive: true,
                            field: "",
                            display: "60.1(3) that the $PM_NAME does not provide something that it is to provide",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 28,
                            isActive: true,
                            field: "",
                            display: "60.1(4) that the $SUPPLIER_NAME receives a Task Order after the starting date in the Task Order",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 29,
                            isActive: true,
                            field: "",
                            display: "60.1(5) of an instruction to stop or not start work",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 30,
                            isActive: true,
                            field: "",
                            display: "60.1(6) that the Client, the Contractor or Others do not work within the stated constraints",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 31,
                            isActive: true,
                            field: "",
                            display: "60.1(7) that the $PM_NAME does not reply to a communication",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 32,
                            isActive: true,
                            field: "",
                            display: "60.1(8) that the $PM_NAME has changed a decision",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 33,
                            isActive: true,
                            field: "",
                            display: "60.1(9) that the $PM_NAME withholds an acceptance",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 34,
                            isActive: true,
                            field: "",
                            display: "60.1(10) that a test or inspection causes unnecessary delay",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 35,
                            isActive: true,
                            field: "",
                            display: "60.1(11) of a change to the Affected Property",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 36,
                            isActive: true,
                            field: "",
                            display: "60.1(12) of an event which is the $CLIENT_NAME's or $PM_NAME liability",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 37,
                            isActive: true,
                            field: "",
                            display: "60.1(13) that the $PM_NAME does not provide material for testing",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 38,
                            isActive: true,
                            field: "",
                            display: "60.1(14) that the $PM_NAME notifies a correction to an assumption",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 39,
                            isActive: true,
                            field: "",
                            display: "60.1(15) of a breach by the $PM_NAME",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 40,
                            isActive: true,
                            field: "",
                            display: "60.1(16) of an instruction to correct a mistake in the Price List",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 41,
                            isActive: true,
                            field: "",
                            display: "60.1(17) that a quotation for a proposed instruction is not accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 19,
                            isActive: true,
                            field: "",
                            display: "60.1(18) additional compensation events stated in Subcontract Data part one",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 20,
                            isActive: true,
                            field: "",
                            display: "X2.1 a change in the law",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 22,
                            isActive: true,
                            field: "",
                            display: "X12.3(6) a change in the Partnering Information",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 23,
                            isActive: true,
                            field: "",
                            display: "X12.3(7) a change in the Partnering timetable",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 24,
                            isActive: true,
                            field: "",
                            display: "Y2.5 suspension of performance",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ReplyRejectOptions",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "faultpscp",
                            display: "arises from a fault of the Subcontractor",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "notexpectnothappen",
                            display: "has not happened and is not expected to happen",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "notnotifiedwithintimescales",
                            display: "has not been notified within the timescales set out in these conditions of subcontract",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "noteffectcostcompletion",
                            display: "has no effect upon Defined Cost or a Task Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "statedcontract",
                            display: "is not one of the compensation events stated in this contract",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CompensationStatuses",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "APMA",
                            display: "Quote Not Accepted - $PM_NAME to make own Assessment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "ARQ",
                            display: "Quote Not Accepted - $SUPPLIER_NAME to resubmit",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "AM",
                            display: "$PM_NAME Assessment Made",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "QA",
                            display: "Quote Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "APMRQ",
                            display: "Awaiting $PM_NAME Response to quote",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "APMR",
                            display: "Awaiting $PM_NAME Response to CEN",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "AQ",
                            display: "Awaiting Quote",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "NC",
                            display: "Not Communicated",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "R",
                            display: "Not a Compensation Event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "DNG",
                            display: "Proposed instruction will not be given",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "QuoteStatuses",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "0",
                            display: "Not Accepted, $SUPPLIER_NAME to resubmit",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "1",
                            display: "Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "2",
                            display: "Awaiting Response",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "3",
                            display: "Not Accepted - $PM_NAME to make assessment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "4",
                            display: "Not Accepted - Other quote approved",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "5",
                            display: "Not Accepted - Proposed instruction will not be given",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "none",
                            display: "Not Communicated",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "InstructionReplyProceedOpts",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "61.1",
                            display: "$SUPPLIER_NAME is instructed to proceed with works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "61.2",
                            display: "$SUPPLIER_NAME is instructed to NOT proceed with works",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "QuoteProgrammeImpactOpts",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "noeffect",
                            display: "There is no effect on the $COMPLETION_DATE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: false,
                            field: "mitigated",
                            display: "There is an effect on the $COMPLETION_DATE but this has been mitigated by measures as detailed",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "notmitigated",
                            display: "There is an effect on the $COMPLETION_DATE which we are unable to mitigate",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "TaskOrderOptionEnabled",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "TaskOrderOptionEnabled",
                            display: "Active-Inactive state indicates whether Task-Order can be selected in CEN communications",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ProposedInstructionClauses",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "65.1 Proposed instruction",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "InstructionReplyProceedEnabled",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "InstructionReplyProceedEnabled",
                            display: "Proposed instructions Quote Reply field proceed options Enabled/Disabled",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "InstructionReplyOpts",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "1",
                            display: "QuoteStatus_1",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "0",
                            display: "QuoteStatus_0",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "3",
                            display: "QuoteStatus_3",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "5",
                            display: "QuoteStatus_5",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "PMCENReplyOpts",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "1",
                            display: "QuoteStatus_1",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "0",
                            display: "QuoteStatus_0",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "3",
                            display: "QuoteStatus_3",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "5",
                            display: "QuoteStatus_5",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "SupplierCENReplyOpts",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "1",
                            display: "QuoteStatus_1",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "0",
                            display: "QuoteStatus_0",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "3",
                            display: "QuoteStatus_3",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "5",
                            display: "QuoteStatus_5",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "OverdueExtensionsEnabled",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "OverdueExtensionsEnabled",
                            display: "Active-Inactive state indicates whether or not a PM or Supplier extension request can be accepted after the due date ",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "PmCompensationAQ",
                            display: "$WF_5_TITLE awaiting quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "PmCompensationARQ",
                            display: "$WF_5_TITLE awaiting revised quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "PmCompensationAPMRQ",
                            display: "$WF_5_TITLE awaiting reply to quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "PmCompensationAPMA",
                            display: "$WF_5_TITLE awaiting assessment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "SupCompensationAQ",
                            display: "$WF_7_TITLE awaiting quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "SupCompensationARQ",
                            display: "$WF_7_TITLE awaiting revised quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "SupCompensationAPMR",
                            display: "$WF_7_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "SupCompensationAPMRQ",
                            display: "$WF_7_TITLE awaiting reply to quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "SupCompensationAPMA",
                            display: "$WF_7_TITLE awaiting assessment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "PmProposedAQ",
                            display: "$WF_6_TITLE awaiting quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "PmProposedARQ",
                            display: "$WF_6_TITLE awaiting revised quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "PmProposedAPMRQ",
                            display: "$WF_6_TITLE awaiting reply to quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 13,
                            isActive: true,
                            field: "PmProposedAPMA",
                            display: "$WF_6_TITLE awaiting assessment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 15,
                            isActive: true,
                            field: "SupAssumption",
                            display: "$WF_42_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 21,
                            isActive: true,
                            field: "SupClaimAPMR",
                            display: "$WF_37_TITLE awaiting reply to notice",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 16,
                            isActive: true,
                            field: "SupClaimAQ",
                            display: "$WF_37_TITLE awaiting quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 17,
                            isActive: true,
                            field: "SupClaimARQ",
                            display: "$WF_37_TITLE awaiting revised quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 19,
                            isActive: true,
                            field: "SupClaimAPMRQ",
                            display: "$WF_37_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 20,
                            isActive: true,
                            field: "SupClaimAPMA",
                            display: "$WF_37_TITLE awaiting determination",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 22,
                            isActive: true,
                            field: "replydraftpmcequotessupplier",
                            display: "$WF_7_TITLE quotations",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 25,
                            isActive: true,
                            field: "COMPENSATION_CWN_APMR",
                            display: "$WF_67_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 23,
                            isActive: true,
                            field: "COMPENSATION_CWN_AQ",
                            display: "$WF_67_TITLE awaiting reply awaiting full details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 24,
                            isActive: true,
                            field: "COMPENSATION_CWN_ARQ",
                            display: "$WF_67_TITLE awaiting reply awaiting revised details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 26,
                            isActive: true,
                            field: "COMPENSATION_CWN_APMRQ",
                            display: "$WF_67_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 27,
                            isActive: true,
                            field: "COMPENSATION_CWN_APMA",
                            display: "$WF_67_TITLE awaiting determination",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 28,
                            isActive: true,
                            field: "COMPENSATION_CLIENTCWN_AQ",
                            display: "$WF_75_TITLE awaiting full details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 29,
                            isActive: true,
                            field: "COMPENSATION_CLIENTCWN_ARQ",
                            display: "$WF_75_TITLE awaiting revised details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 30,
                            isActive: true,
                            field: "COMPENSATION_CLIENTCWN_APMR",
                            display: "$WF_75_TITLE awaiting reply to notice",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 31,
                            isActive: true,
                            field: "COMPENSATION_CLIENTCWN_APMRQ",
                            display: "$WF_75_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 32,
                            isActive: true,
                            field: "COMPENSATION_CLIENTCWN_APMA",
                            display: "$WF_75_TITLE awaiting determination",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 33,
                            isActive: true,
                            field: "COMPENSATION_CLIENT_AQ",
                            display: "$WF_76_TITLE awaiting quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 34,
                            isActive: true,
                            field: "COMPENSATION_CLIENT_ARQ",
                            display: "$WF_76_TITLE awaiting revised quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 35,
                            isActive: true,
                            field: "COMPENSATION_CLIENT_APMR",
                            display: "$WF_76_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 36,
                            isActive: true,
                            field: "COMPENSATION_CLIENT_APMRQ",
                            display: "$WF_76_TITLE awaiting reply to quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 37,
                            isActive: true,
                            field: "COMPENSATION_CLIENT_APMA",
                            display: "$WF_76_TITLE awaiting assessment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 14,
                            isActive: true,
                            field: "PmExtension",
                            display: "$WF_9_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 38,
                            isActive: true,
                            field: "SupExtension",
                            display: "$WF_10_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CompensationEventsAcceptanceOptions",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "1",
                            display: "Is a compensation event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "0",
                            display: "Is not a compensation event",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 104,
            title: "Plans & Programmes",
            workflows: [
                {
                    id: 14,
                    title: "$SUPPLIER_NAME Plan/Programme",
                    notificationName: "Plan",
                    abbreviation: "$SUPPLIER_ABBREVIATION-PLAN_PROG-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "PROGRAMME_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "ReasonLabel",
                            display: "Reason for any changes",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "ChangeLabel",
                            display: "Change in any other important milestone in period and reasons why",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "MainProgressLabel",
                            display: "Main progress achieved in period",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "KeyActivitiesLabel",
                            display: "Key activities forecast before the next submission",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "SummaryLabel",
                            display: "Summary of critical path",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "ChangesLabel",
                            display: "Main changes made in period",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "CompensationLabel",
                            display: "Compensation events added this period",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "NotificationClause",
                            display: "Please find attached a Plan for acceptance",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "ReplyRejectReasonLabel",
                            display: "The $SUPPLIER_NAME’s plan is not accepted for the following reasons",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "ReplyNotificationClause",
                            display: "In accordance with the conditions of contract you are notified that the $SUPPLIER_NAME’s plan",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "ReplyNotificationClause",
                            display: "You are notified that the $SUPPLIER_NAME’s plan",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "ReferenceLabel",
                            display: "Plan Reference",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ReplyRejectOptions",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "plansnotpractical",
                            display: "The $SUPPLIER_NAME’s plans which it shows are not practical",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "missingcontractrequires",
                            display: "It does not show the information which this contract requires",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "notrepresentplan",
                            display: "It does not represent the $SUPPLIER_NAME’s plans realistically",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "notcomply",
                            display: "It does not comply with the Scope",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "DashboardDisplayPlannedCompletionOnLatest",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "DashboardDisplayPlannedCompletionOnLatest",
                            display: "Active-Inactive state indicates whether (Planned Completion shown on the latest Accepted Programme) is displayed on dasboard",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "Fields",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "PreviousPlanned",
                            display: "Previous Planned Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: false,
                            field: "PlannedCompletion",
                            display: "Date of Planned Completion this period",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: false,
                            field: "Changes",
                            display: "Main changes made in period",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Reason",
                            display: "Reason for any changes since last period",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "Change",
                            display: "Change in any other important project milestone in period and reasons why",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "MainProgress",
                            display: "Main progress achieved in period",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: false,
                            field: "KeyActivities",
                            display: "Key activities forecast in next reporting period",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: false,
                            field: "Summary",
                            display: "Summary of critical path",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "Compensation",
                            display: "Compensation events added to plan this period",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Supplier",
                            display: "$WF_14_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "UnifiedReplyOptions",
                    values: [
                        {
                            id: 1,
                            wfid: 14,
                            isActive: true,
                            field: "ACCEPT",
                            display: "Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            wfid: 14,
                            isActive: false,
                            field: "ACCEPT_WITH_COMMENTS",
                            display: "Accepted with comments",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            wfid: 14,
                            isActive: true,
                            field: "NOT_ACCEPTED",
                            display: "Not accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            wfid: 14,
                            isActive: true,
                            field: "NOT_ACCEPTED_RESUBMIT",
                            display: "Not accepted - resubmission required",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "SUPPLIER",
                                    actionType: "WF_14",
                                    timePeriod: "SUPPLIER_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 5,
                            wfid: 14,
                            isActive: false,
                            field: "NO_REPLY_REQUIRED",
                            display: "Reply not required",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 105,
            title: "Notifications",
            workflows: [
                {
                    id: 15,
                    title: "$PM_NAME Notifications",
                    notificationName: "Notification",
                    abbreviation: "$PM_ABBREVIATION-Notification-",
                    notify: true,
                    replyEnabled: false,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "PM_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "PM",
                    replyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                },
                {
                    id: 16,
                    title: "$SUPPLIER_NAME Notifications",
                    notificationName: "Notification",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Notification-",
                    notify: true,
                    replyEnabled: false,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "PM_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "PmClauses",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "13.2 of a change of address for communications",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "",
                            display: "13.5 of an agreement to extend the period for reply for a communication (excluding compensation events periods)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "",
                            display: "14.2 of the cancellation of a delegation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "",
                            display: "16.2 that the $PM_NAME or $CLIENT_NAME is considering a proposal",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "",
                            display: "17.1 of an ambiguity or inconsistency",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: true,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_4",
                                    timePeriod: "PM_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "",
                            display: "17.2 of an illegal or impossible requirement",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_4",
                                    timePeriod: "PM_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 8,
                            isActive: false,
                            field: "",
                            display: "19.2 of a reply to a quotation for a Task",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: false,
                            field: "",
                            display: "19.3 of an extension to the period to submit a quotation or reply to a quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: false,
                            field: "",
                            display: "23.2 of an assessment of the amount to be paid as the Contractor failed to provide services",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "",
                            display: "24.3 of an agreement that submission of Subsubcontract documents is not needed",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "",
                            display: "25.2 to provide access to the work being done and Plant and Materials being stored to those named",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 13,
                            isActive: true,
                            field: "",
                            display: "26.1 of an intention to transfer the benefit of the subcontract",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 14,
                            isActive: true,
                            field: "",
                            display: "41.3 of a test or inspection or the result of a test or inspection",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 15,
                            isActive: false,
                            field: "",
                            display: "41.6 of an assessment of the amount to be paid for repeating a test or inspection",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 16,
                            isActive: true,
                            field: "",
                            display: "42.1 that Plant and Materials have passed a test or inspection",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 18,
                            isActive: false,
                            field: "",
                            display: "43.3 of the amount to be paid for uncorrected Defects",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 17,
                            isActive: true,
                            field: "",
                            display: "44.1 of a proposal to accept a Defect",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 43,
                            isActive: true,
                            field: "",
                            display: "44.1 of agreement to consider a proposal to change the Scope so that a Defect does not have to be corrected",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 19,
                            isActive: false,
                            field: "",
                            display: "44.2 of the cost the Contractor would incur in correcting a Defect",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 21,
                            isActive: true,
                            field: "",
                            display: "50.9 of acceptance that part of the Defined Cost is correct (main Options C and E)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 22,
                            isActive: true,
                            field: "",
                            display: "50.9 that further records in respect of Defined Cost are needed (main Options C and E)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 23,
                            isActive: true,
                            field: "",
                            display: "50.9 of errors in the Contractor’s assessment (main Options C and E)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 24,
                            isActive: false,
                            field: "",
                            display: "50.9 of the correct assessment of the part of the Defined Cost (main Options C and E)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 25,
                            isActive: false,
                            field: "",
                            display: "53.1 of certification of the final payment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 26,
                            isActive: false,
                            field: "",
                            display: "54.3 of the final assessment of the Contractor's share (main Option C)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 27,
                            isActive: true,
                            field: "",
                            display: "61.5 that the $PM_NAME has decided the $SUPPLIER_NAME did not give early warning of a compensation event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 28,
                            isActive: true,
                            field: "",
                            display: "61.6 that an assumption on which a compensation event quotation is based was wrong",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 30,
                            isActive: true,
                            field: "",
                            display: "90.1 of a wish to terminate",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 31,
                            isActive: false,
                            field: "",
                            display: "90.1 of the issue of a termination certificate",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 32,
                            isActive: true,
                            field: "",
                            display: "91.2 of a default/of the $SUPPLIER_NAME having not put right a default",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 33,
                            isActive: true,
                            field: "",
                            display: "91.3 of a default/of the $SUPPLIER_NAME having not put right a default",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 34,
                            isActive: true,
                            field: "",
                            display: "92.2 that Equipment is no longer required",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 35,
                            isActive: true,
                            field: "",
                            display: "X18.6 of a matter for which the $SUPPLIER_NAME is liable",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 36,
                            isActive: true,
                            field: "",
                            display: "X19.1 of a wish to terminate",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 37,
                            isActive: false,
                            field: "",
                            display: "X19.1 of the issue of a termination certificate",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 38,
                            isActive: true,
                            field: "",
                            display: "X23.1 extension of the Service Period",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 39,
                            isActive: false,
                            field: "",
                            display: "X24.1 assessment of final amount due in accounting period",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 40,
                            isActive: true,
                            field: "",
                            display: "Y2.3 of an intention to pay less than the notified sum",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 41,
                            isActive: true,
                            field: "",
                            display: "Y3.3 of the name of the beneficiary",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 42,
                            isActive: true,
                            field: "",
                            display: "Other notification",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "SupplierClauses",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "13.2 of a change of address for communications",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "",
                            display: "17.1 of an ambiguity or inconsistency",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_4",
                                    timePeriod: "PM_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "",
                            display: "17.2 of an illegal or impossible requirement",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_4",
                                    timePeriod: "PM_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 17,
                            isActive: true,
                            field: "",
                            display: "20.3 of advice on the practical implications of the Accepted Plan and subcontracting arrangements (main Options C and E)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 14,
                            isActive: true,
                            field: "",
                            display: "26.1 of an intention to transfer the benefit of the contract or any rights under it",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "",
                            display: "31.3 of a failure by the $PM_NAME to notify acceptance or non acceptance of the plan",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "",
                            display: "33.3 of a failure by the $PM_NAME to notify acceptance or non acceptance of the programme",
                            effect: "PROG_DEEM_START_INTERVAL",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "",
                            display: "50.9 of when the Defined Cost of part of the works had been finalised (main Options C and E)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "",
                            display: "61.4 of a failure by the $PM_NAME to respond to a compensation event notification",
                            effect: "CEN_DEEM_START_INTERVAL",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "",
                            display: "62.6 of a failure by the $PM_NAME to respond to a quotation",
                            effect: "DEEM_START_INTERVAL",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "",
                            display: "64.4 of a failure by the $PM_NAME to make an assessment of a compensation event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "",
                            display: "90.1 of a wish to terminate",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 15,
                            isActive: true,
                            field: "",
                            display: "W1.1(1) of a replacement Senior Representative",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 16,
                            isActive: true,
                            field: "",
                            display: "X10.4(2) of a failure of the $PM_NAME to reply to the submission of a first Information Execution Plan",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "",
                            display: "Y2.3 of an intention to pay less than the notified sum",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 13,
                            isActive: true,
                            field: "",
                            display: "Other notification",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 4,
                            isActive: true,
                            field: "Client",
                            display: "$WF_57_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "PM",
                            display: "$WF_15_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Supervisor",
                            display: "$WF_16_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 1,
                            isActive: true,
                            field: "Supplier",
                            display: "$WF_17_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "PmToSupervisor",
                            display: "$WF_58_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "PmToClient",
                            display: "$WF_59_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "SupplierToSupervisor",
                            display: "$WF_81_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "SupervisorToPm",
                            display: "$WF_60_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "ClientToClient",
                            display: "$WF_64_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "PmToPm",
                            display: "$WF_63_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "SupplierToSupplier",
                            display: "$WF_65_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "SupervisorToSupervisor",
                            display: "$WF_66_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 106,
            title: "Submissions",
            workflows: [
                {
                    id: 18,
                    title: "$SUPPLIER_NAME Submissions",
                    notificationName: "Submission",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Submission-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "PM_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    form_IncludeCompanyName: false,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]"
                    }
                },
                {
                    id: 49,
                    title: "$PM_NAME Submissions",
                    notificationName: "Submission",
                    abbreviation: "$PM_ABBREVIATION-Submission-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "PM_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "PM",
                    replyingParty: "SUPPLIER",
                    form_IncludeCompanyName: false,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "IssueClauses",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "16.1 a proposal to reduce the amount the $PM_NAME pays to the $SUPPLIER_NAME",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "",
                            display: "16.3 a proposal to add an area to the Service Area",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 26,
                            isActive: true,
                            field: "",
                            display: "19.2 of a quotation for a Task",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "",
                            display: "20.4 forecasts of the total Defined Cost for the whole of the service (main Options C and E)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "",
                            display: "21.1 particulars of design for an item of Equipment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "",
                            display: "22.1 details of a replacement person",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "",
                            display: "24.2 the name of a proposed Subcontractor",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "",
                            display: "24.3 proposed subcontract documents",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 45,
                            isActive: true,
                            field: "",
                            display: "24.4 of pricing information for each subcontract (main Options C and E)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 46,
                            isActive: true,
                            field: "",
                            display: "25.1 of things for approval",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "",
                            display: "26.4 pricing information in a proposed subcontract document (main Options C and E)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 47,
                            isActive: true,
                            field: "",
                            display: "33.1 of a Task Order programme",
                            applyReplyPeriod: true,
                            replyPeriod: 7,
                            noReply: false,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 48,
                            isActive: true,
                            field: "",
                            display: "34.1 of a revised Task Order programme",
                            applyReplyPeriod: true,
                            replyPeriod: 7,
                            noReply: false,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "",
                            display: "40.2 a proposed quality policy statement or quality policy plan",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "",
                            display: "44.2 a proposal to accept a Defect",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "",
                            display: "50.9 records to demonstrate Defined Cost is correctly assessed (main Options C and E)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 43,
                            isActive: true,
                            field: "",
                            display: "50.9 of further records in connection with Defined Cost (main Options C and E)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 13,
                            isActive: true,
                            field: "",
                            display: "55.3 a revision of the Price List",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 14,
                            isActive: true,
                            field: "",
                            display: "84.1 certificates of insurance",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 15,
                            isActive: true,
                            field: "",
                            display: "X4.1 an ultimate holding company guarantee",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 44,
                            isActive: true,
                            field: "",
                            display: "X4.2 of an alternative guarantor",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 16,
                            isActive: true,
                            field: "",
                            display: "X10.4(1) of a first Information Execution Plan",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 17,
                            isActive: true,
                            field: "",
                            display: "X10.4(3) a revised Information Execution Plan",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 18,
                            isActive: true,
                            field: "",
                            display: "X13.1 a performance bond",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 19,
                            isActive: true,
                            field: "",
                            display: "X20.2 a report of performance",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 20,
                            isActive: true,
                            field: "",
                            display: "X20.3 proposals for improving performance",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 21,
                            isActive: true,
                            field: "",
                            display: "X21.1 a proposal to reduce the cost of operating and maintaining an asset",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 27,
                            isActive: false,
                            field: "",
                            display: "X22.1(1) of a forecast of the total Defined Cost for the work in Stage One",
                            applyReplyPeriod: true,
                            replyPeriod: 7,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 28,
                            isActive: false,
                            field: "",
                            display: "X22.3(1) a design proposal for Stage Two",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 34,
                            isActive: true,
                            field: "",
                            display: "X29.4(1) of a first climate change plan for acceptance",
                            applyReplyPeriod: true,
                            replyPeriod: 14,
                            noReply: false,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 36,
                            isActive: true,
                            field: "",
                            display: "X29.4(4) of a revised climate change plan for acceptance",
                            applyReplyPeriod: true,
                            replyPeriod: 14,
                            noReply: false,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 38,
                            isActive: true,
                            field: "",
                            display: "X29.11(1) of a proposal to change the Scope to reduce the impact on climate change",
                            applyReplyPeriod: false,
                            noReply: false,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 40,
                            isActive: true,
                            field: "",
                            display: "X29.12(1) of a report of performance against the targets in the Performance Table",
                            applyReplyPeriod: false,
                            noReply: true,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 42,
                            isActive: true,
                            field: "",
                            display: "X29.12(2) of a proposal for improving performance for acceptance",
                            applyReplyPeriod: false,
                            noReply: false,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 29,
                            isActive: false,
                            field: "",
                            display: "Y1.4 details of the banking arrangement for the Project Bank Account",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 30,
                            isActive: false,
                            field: "",
                            display: "Y1.6 a proposal to add a $SUPPLIER_NAME to the Named Suppliers",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 31,
                            isActive: true,
                            field: "",
                            display: "Y1.9 the Authorisation setting out sums due to the Named Suppliers",
                            applyReplyPeriod: false,
                            noReply: true,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 32,
                            isActive: true,
                            field: "",
                            display: "Other submission",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "IssueClausesPM",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "85.1 of the cost of insurance provided by the $PM_NAME",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 1,
                            isActive: true,
                            field: "",
                            display: "86.1 of certificates of insurance provided by the $CLIENT_NAME",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "UnifiedReplyOptions",
                    values: [
                        {
                            id: 1,
                            wfid: 18,
                            isActive: true,
                            field: "ACCEPT",
                            display: "Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            wfid: 18,
                            isActive: false,
                            field: "ACCEPT_WITH_COMMENTS",
                            display: "Accepted with comments",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            wfid: 18,
                            isActive: true,
                            field: "NOT_ACCEPTED",
                            display: "Not accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            wfid: 18,
                            isActive: true,
                            field: "NOT_ACCEPTED_RESUBMIT",
                            display: "Not accepted - resubmission required",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "SUPPLIER",
                                    actionType: "WF_18",
                                    timePeriod: "SUPPLIER_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 5,
                            wfid: 18,
                            isActive: false,
                            field: "NO_REPLY_REQUIRED",
                            display: "Reply not required",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            wfid: 49,
                            isActive: true,
                            field: "ACCEPT",
                            display: "Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            wfid: 49,
                            isActive: false,
                            field: "ACCEPT_WITH_COMMENTS",
                            display: "Accepted with comments",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            wfid: 49,
                            isActive: true,
                            field: "NOT_ACCEPTED",
                            display: "Not accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            wfid: 49,
                            isActive: true,
                            field: "NOT_ACCEPTED_RESUBMIT",
                            display: "Not accepted - resubmission required",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_49",
                                    timePeriod: "PM_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 10,
                            wfid: 49,
                            isActive: false,
                            field: "NO_REPLY_REQUIRED",
                            display: "Reply not required",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Supplier",
                            display: "$WF_18_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "PM",
                            display: "$WF_49_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 107,
            title: "Submissions (with quote)",
            workflows: [
                {
                    id: 19,
                    title: "$SUPPLIER_NAME Submissions (wq)",
                    notificationName: "Submission",
                    abbreviation: "CON-SubmissionWQ-",
                    notify: true,
                    replyEnabled: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "PM_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    form_IncludeCompanyName: false,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CostEffectLabel",
                            display: "Change in the Prices",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "DaysEffectLabel",
                            display: "The length of time that the $COMPLETION_DATE is delayed",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "WarningBanner",
                            display: "Do not use this workflow for a Task Order quotation.",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ProposalClauses",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "44.2 of a quotation to accept a Defect",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "",
                            display: "X21.2 a quote to reduce the cost of operating and maintaining an asset",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: false,
                            field: "",
                            display: "X29.11(2) of a quotation for a change to reduce the impact on climate change",
                            applyReplyPeriod: false,
                            noReply: false,
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "UnifiedReplyOptions",
                    values: [
                        {
                            id: 1,
                            wfid: 19,
                            isActive: true,
                            field: "ACCEPT",
                            display: "Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            wfid: 19,
                            isActive: false,
                            field: "ACCEPT_WITH_COMMENTS",
                            display: "Accepted with comments",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            wfid: 19,
                            isActive: true,
                            field: "NOT_ACCEPTED",
                            display: "Not accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            wfid: 19,
                            isActive: true,
                            field: "NOT_ACCEPTED_RESUBMIT",
                            display: "Not accepted - resubmission required",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "SUPPLIER",
                                    actionType: "WF_19",
                                    timePeriod: "SUPPLIER_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 5,
                            wfid: 19,
                            isActive: false,
                            field: "NO_REPLY_REQUIRED",
                            display: "Reply not required",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Supplier",
                            display: "$WF_19_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 116,
            title: "Forecasts",
            workflows: [
                {
                    id: 52,
                    title: "Cost Forecasts",
                    notificationName: "Cost Forecast",
                    abbreviation: "$SUPPLIER_ABBREVIATION-CostForecast-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CostForecastWarningBanner",
                            display: "The forecast is to be submitted at the interval stated in the Contract Data and in the format included in the Scope.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "CarbonForecastWarningBanner",
                            display: "The forecast is to be submitted at the interval stated in the Contract Data for Defined Cost forecast and in the format included in the Scope.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "TargetLabel",
                            display: "Target",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "ForecastLabel",
                            display: "Forecast",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "ActualLabel",
                            display: "Actual",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "VarianceLabel",
                            display: "Variance",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: []
                },
                {
                    replacementKey: "CostForecastClauses",
                    values: [
                        {
                            id: 29,
                            isActive: true,
                            field: "",
                            display: "NEC4 TSS Option C - as per Clause 20.4",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 30,
                            isActive: true,
                            field: "",
                            display: "NEC4 TSS Option E - as per Clause 20.4",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CarbonForecastClauses",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "",
                            display: "NEC4 PSC - whole life carbon of the proposed solution",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "NEC4 ECC - capital carbon of the built solution",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CostForecastClausesEnabled",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CostForecastClausesEnabled",
                            display: "Active-Inactive state indicates \"Type\" field will be included in registers and and communication forms",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CarbonForecastClausesEnabled",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "CarbonForecastClausesEnabled",
                            display: "Active-Inactive state indicates \"Type\" field will be included in registers and communication forms",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "Fields",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "Target",
                            display: "Target",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Forecast",
                            display: "Forecast",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "Actual",
                            display: "Actual",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "Variance",
                            display: "Variance",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 108,
            title: "Payments",
            workflows: [
                {
                    id: 21,
                    title: "$SUPPLIER_NAME Payment Applications",
                    notificationName: "Payment Application",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Payment-",
                    notify: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    notifyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                },
                {
                    id: 20,
                    title: "$PM_NAME Payment Certificates",
                    notificationName: "Payment Certificate",
                    abbreviation: "$PM_ABBREVIATION-Payment-",
                    notify: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CumulativePriceLabel",
                            display: "Price for Services Provided to Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "PlusAmountsSupplierLabel",
                            display: "Plus other amounts to be paid to the $SUPPLIER_NAME",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "LessAmountsSupplierLabel",
                            display: "Less amounts to be paid by or retained from the $SUPPLIER_NAME",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "TaxSupplierLabel",
                            display: "Tax which the law requires the Employer to pay to the $SUPPLIER_NAME",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "WarningBanner",
                            display: "The first assessment date is no later than the assessment interval after the starting date. Subsequent assessment dates are the assessment interval after the previous assessment. Assessments continue until 4 weeks after the end of the Service Period or the issue of the termination certificate.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "SummaryDetailsLabel",
                            display: "Summary details",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "TaxEnabled",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "TaxEnabled",
                            display: "Active-Inactive state indicates tax field will be included in notification forms",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "PaymentTypes",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "INTERIM",
                            display: "51.1 Certification of payment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 1,
                            isActive: true,
                            field: "FINAL",
                            display: "53.1 Certification of a final payment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "SUPPLEMENTARY",
                            display: "Supplementary",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "MandateAttachment",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "MandateAttachment",
                            display: "Active-Inactive state indicates weather attachment is mandatory on Payment Application and Certifications",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: []
                },
                {
                    replacementKey: "PONumberEnabled",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "PONumberEnabled",
                            display: "Purchase Order number field will be included in notification forms",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 119,
            title: "Other Assessments",
            workflows: [
                {
                    id: 77,
                    title: "$PM_NAME Assessments (excluding CE's and Payments)",
                    notificationName: "Assessment",
                    abbreviation: "$PM_ABBREVIATION-Other-Assessment-",
                    notify: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: []
                },
                {
                    replacementKey: "ActionReminders",
                    values: []
                },
                {
                    replacementKey: "FieldsPM",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Subject",
                            display: "Subject",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Type",
                            display: "Type",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Description",
                            display: "Description",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "EffectContractPrice",
                            display: "Affect contract price",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "Amount",
                            display: "Amount",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: false,
                            field: "EffectContractCompletion",
                            display: "Affect contract date(s)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: false,
                            field: "Days",
                            display: "Time (days)",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ClausesPM",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "",
                            display: "23.2 of cost incurred by the $PM_NAME as a result of the $SUPPLIER_NAME not providing the services and other things which it is to provide",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "41.6 of cost incurred by the $PM_NAME in repeating a test or inspection",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "",
                            display: "43.3 of the cost to the $PM_NAME of having a Defect corrected by other people",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "",
                            display: "50.9 of the correct assessment of the Defined Cost for a part of the service that has been finalised (main Options C and E)",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "",
                            display: "51.2 of interest due to late payment",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "",
                            display: "51.3 of interest on a correcting amount",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "",
                            display: "54.3 of the final assessment of the Contractor's share (main Option C)",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "",
                            display: "85.1 of the cost to the $PM_NAME of insurance that the $SUPPLIER_NAME should have provided",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "",
                            display: "86.3 of the cost to the $SUPPLIER_NAME of insurance that the $PM_NAME should have provided",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "",
                            display: "93.3 of the Subcontractor's share on termination",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "",
                            display: "X1.3 of the adjustment for inflation to be added to the Prices (Options A and B)",
                            effect: "EFFECT_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 13,
                            isActive: true,
                            field: "",
                            display: "X1.4 of the adjustment for inflation to be added to the Price for Service Provided to Date (Options C and E)",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 14,
                            isActive: true,
                            field: "",
                            display: "X17 of the amount of low performance damages",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 15,
                            isActive: true,
                            field: "",
                            display: "X20.4 of the amount payable for meeting a target on the incentive schedule",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 17,
                            isActive: true,
                            field: "",
                            display: "X24.1 Assessment of final amount due in accounting period",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 16,
                            isActive: true,
                            field: "",
                            display: "X29.1 of the adjustment to payment if a measured performance is higher, the same or lower than its target",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 117,
            title: "Other Certificates",
            workflows: [
                {
                    id: 68,
                    title: "$PM_NAME Certificates",
                    notificationName: "Certificate",
                    abbreviation: "$PM_ABBREVIATION-Certificate-",
                    notify: true,
                    replyEnabled: false,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "PM_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "PM",
                    replyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Cost Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "PmCertificateText",
                            display: "",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "SupplierCertificateText",
                            display: "",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "ClientCertificateText",
                            display: "",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "SupervisorCertificateText",
                            display: "",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CompletionFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Completion Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "Defects",
                            display: "Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "SectionalCompletionFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Sectional Completion Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "Defects",
                            display: "Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "TakingOverFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Taking Over Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "Defects",
                            display: "Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "DefectsFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Certified Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "Defects",
                            display: "Outstanding Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "TerminationFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Certified Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "Defects",
                            display: "Outstanding Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "OtherFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Certified Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "Defects",
                            display: "Outstanding Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "TaskOrderCompletionFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Certified Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "Defects",
                            display: "Outstanding Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ProjectOrderCompletionFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Certified Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "Defects",
                            display: "Outstanding Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ReplyOptions",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Accepted",
                            display: "Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Not Accepted",
                            display: "Not Accepted",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "PMCertTypes",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "",
                            display: "Completion Certificate",
                            effect: "COMPLETION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: false,
                            field: "",
                            display: "Sectional Completion Certificate",
                            effect: "SECTIONAL_COMPLETION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "",
                            display: "Taking Over Certificate",
                            effect: "TAKING_OVER",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "",
                            display: "Defects Certificate",
                            effect: "DEFECTS",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "",
                            display: "90.1 Termination Certificate",
                            effect: "TERMINATION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "",
                            display: "X19 Termination Certificate",
                            effect: "TERMINATION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: false,
                            field: "",
                            display: "Task Order Completion",
                            effect: "TASK_ORDER_COMPLETION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: false,
                            field: "",
                            display: "Project Order Completion",
                            effect: "PROJECT_ORDER_COMPLETION",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CompletionChangesStateEnabled",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CompletionChangesStateEnabled",
                            display: "Indicate whether communication of a Completion Certificate should change the contract state",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "PM",
                            display: "$WF_68_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Supplier",
                            display: "$WF_69_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Client",
                            display: "$WF_70_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "Supervisor",
                            display: "$WF_71_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 109,
            title: "Quality Management",
            workflows: [
                {
                    id: 23,
                    title: "$PM_NAME Defect Notifications",
                    notificationName: "Defect Notification",
                    abbreviation: "$PM_ABBREVIATION-Defect-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    actioningParty: "PM",
                    resolveActioningParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        actionTab: {
                            actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]",
                        resolveActionTab: {
                            resolveActionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        }
                    }
                },
                {
                    id: 24,
                    title: "$SUPPLIER_NAME Defect Notifications",
                    notificationName: "Defect Notification",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Defect-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "SUPPLIER",
                    actioningParty: "PM",
                    resolveActioningParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        actionTab: {
                            actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]",
                        resolveActionTab: {
                            resolveActionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        }
                    }
                },
                {
                    id: 26,
                    title: "Master Defect Register",
                    notificationName: "Defect Notification",
                    abbreviation: "Defect",
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "InstructionClauseLabel",
                            display: "You are instructed to search for a Defect as follows",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "SupervisorClauseLabel",
                            display: "You are notified of the following Defect",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "SupplierClauseLabel",
                            display: "You are notified of the following Defect",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "TestsClauseLabel",
                            display: "You are notified of the following test or inspection",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "DefectsWarningBanner",
                            display: "A Defect is not notified after the end of the service period.",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ClosureReasonOptions",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Accepted",
                            display: "Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Corrected",
                            display: "Corrected",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "NoDefect",
                            display: "Not a Defect",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "DefectPlannedClosureEnabled",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "DefectPlannedClosureEnabled",
                            display: "Active-Inactive state indicates \"Defect Planned Closure Date\" field will be included in registers, reports and actions tab",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Instruction",
                            display: "$WF_22_TITLE awaiting closure",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "SuperDefect",
                            display: "$WF_23_TITLE awaiting closure",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "SupplierDefect",
                            display: "$WF_24_TITLE awaiting closure",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Inspection",
                            display: "$WF_25_TITLE awaiting closure",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "SupervisorTestAndInspection",
                            display: "$WF_47_TITLE awaiting closure",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "PMTestAndInspection",
                            display: "$WF_48_TITLE awaiting closure",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "PMNCProposal",
                            display: "$WF_54_TITLE awaiting acceptance",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "NonConformity",
                            display: "$WF_55_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 110,
            title: "Delegated Actions",
            workflows: [
                {
                    id: 27,
                    title: "$PM_NAME Delegated Actions",
                    notificationName: "Delegated Action",
                    abbreviation: "$PM_ABBREVIATION-Action-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "DelegationClause",
                            display: "You are notified that the following actions",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 111,
            title: "Records",
            workflows: [
                {
                    id: 30,
                    title: "$PM_NAME Meetings",
                    notificationName: "Meeting",
                    abbreviation: "$PM_ABBREVIATION-Meeting-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    form_IncludeCompanyName: false,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                },
                {
                    id: 31,
                    title: "$SUPPLIER_NAME Meetings",
                    notificationName: "Meeting",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Meeting-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "SUPPLIER",
                    form_IncludeCompanyName: false,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                },
                {
                    id: 32,
                    title: "$SUPPLIER_NAME Site Diary",
                    notificationName: "Site Diary",
                    abbreviation: "Diary-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "SUPPLIER",
                    form_IncludeCompanyName: false,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                },
                {
                    id: 33,
                    title: "Weather",
                    notificationName: "Weather",
                    abbreviation: "Weather-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "SUPPLIER",
                    form_IncludeCompanyName: false,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                }
            ],
            placeholders: []
        },
        {
            id: 112,
            title: "RFI / TQ",
            workflows: [
                {
                    id: 34,
                    title: "$SUPPLIER_NAME RFI / TQ",
                    notificationName: "RFI / TQ",
                    abbreviation: "RFI/TQ-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "ASKED_ON_COMMUNICATION_FORM",
                    replyPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Supplier",
                            display: "$WF_34_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "PM",
                            display: "$WF_80_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 113,
            title: "Contract Information",
            workflows: [
                {
                    id: 39,
                    title: "Documents",
                    notificationName: "Document",
                    abbreviation: "Documents-",
                    notify: true,
                    actioningParty: "PM",
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        actionTab: {
                            actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        }
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: []
                }
            ]
        }
    ]
};
export default template;